// Libraries
import { Button, Flex, Text } from '@chakra-ui/react';
// Components
import { FormSubmit, ResetIcon } from '@atoms/index';
// Utils
import text from '@translations/en.json';
import { FormFooterProps } from './FormFooter.types';

/**
 * A form footer component containing buttons for resetting and submitting a form.
 *
 * @component
 * @param {FormFooterProps} props - The props for the FormFooter component.
 * @param {Function} props.onClick - Callback fired when the reset button is clicked.
 * @param {string} props.loadingText - The text displayed when the form is in a loading state.
 * @param {boolean} props.isDisabled - Determines if the submit button is disabled.
 * @param {boolean} [props.isLoading=false] - Determines if the form is in a loading state.
 * @returns {ReactElement} The FormFooter component.
 */
export const FormFooter = ({ onClick, loadingText, isDisabled, isLoading = false }: FormFooterProps) => {
  return (
    <Flex w='full' justify='space-between'>
      <Button h={8} name='reset' type='button' onClick={onClick} variant='light' isDisabled={isLoading} ml={-2}>
        <Flex alignItems='center' columnGap={2}>
          <ResetIcon boxSize={3} color='inherit' />
          <Text fontSize='m' color='inherit'>
            {text.cii_simulator.buttons.reset}
          </Text>
        </Flex>
      </Button>
      <FormSubmit
        w={28}
        h={8}
        fontSize='s'
        fontWeight='medium'
        isDisabled={isDisabled}
        isLoading={isLoading}
        loadingText={loadingText}
      >
        {text.cii_simulator.buttons.submit.text}
      </FormSubmit>
    </Flex>
  );
};
